<template>
    <div :class="['custom-field-label-pane__editor', field.field_type]">
        <ElDatePicker
            ref="inputRef"
            v-model="value$"
            format="yyyyMMdd"
            value-format="yyyyMMdd"
            :clearable="false"
            :placeholder="$t(`PtCustomFieldLabelPane.editor.placeholder.${field.field_type}`)"
            @blur="onFinishEdit"
        />
    </div>
</template>

<script>
import DatePicker from 'element-ui/lib/date-picker';

export default {
    name: 'DateEditor',
    components: {
        ElDatePicker: DatePicker,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            value$: '',
        };
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.value$ = this.value;
                if (!this.value || this.value.length !== 8) {
                    this.value$ = '';
                    return;
                }

                this.value$ = this.value;
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.focus();
            }
        });
    },
    methods: {
        onFinishEdit() {
            this.$emit('endLabelingField');
            this.$emit('updateFieldValue', this.value$ || '');
        },
    },
};
</script>
